// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__9Qc3n"};